module.exports = window.UIG_CDN_ReactDOM_16_8;